import { Carousel as BootstrapCarousel } from 'react-bootstrap';
import { ReactNode } from 'react';

interface CarouselItem {
  image: string;
  alt: string;
  caption?: ReactNode;
}

interface CarouselProps {
  items: CarouselItem[];
  className?: string;
  interval?: number;
  autoPlay?: boolean;
}

const Carousel = ({ items, className = '', interval = 5000, autoPlay = true }: CarouselProps) => {
  return (
    <BootstrapCarousel
      className={className}
      fade
      interval={autoPlay ? interval : null}
      pause="hover"
    >
      {items.map((item, index) => (
        <BootstrapCarousel.Item key={index}>
          <img
            className="d-block w-100"
            src={item.image}
            alt={item.alt}
          />
          {item.caption && (
            <BootstrapCarousel.Caption>
              {item.caption}
            </BootstrapCarousel.Caption>
          )}
        </BootstrapCarousel.Item>
      ))}
    </BootstrapCarousel>
  );
};

export default Carousel;
